<template>

  <div>

    <xolas-table
    ref="permitsduetable"
    table-ref="permitsduetable"

    title="Permits Due Report"
    icon="fa fa-list"

    url="/permits"
    :fields="fields"

    sort-field="expiry"
    layer-component="permit"
    :layer-args="{ id: 'id' }">

      <template #permit-controls="props">
        <permit-controls :row-data="props.rowData" />
      </template>

    </xolas-table>


  <br />

  <events-calendar category="permits" />

</div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

import EventsCalendar from '@/components/atoms/EventsCalendar'
import PermitControls from '@/components/sites/permits/PermitControls'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    EventsCalendar,
    PermitControls
  },

  data () {
    return {
      // Per-column widths follow the MEASURED pre-migration baseline for THIS
      // mount (.context/xol-234-baselines/metrics.json permits-due-report[0]),
      // set slightly under the measured values so the total (plus the 70px
      // chevron column) fits the 1291px dashboard container without a
      // horizontal scrollbar — el-table distributes the remaining slack
      // proportionally, landing on the measured widths. (SitePermits.vue's
      // wider values overflowed this narrower dashboard mount and pushed the
      // permit-controls column out of view.)
      fields: [
        {
          name: 'site.siteName',
          title: 'Site',
          minWidth: '141'
        },
        {
          name: 'site.siteId',
          title: 'Site ID',
          minWidth: '82'
        },
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType',
          minWidth: '94'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '59'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '62'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate,
          minWidth: '61'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          minWidth: '40'
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '43'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '114'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '36'
        },
        {
          // Wide enough for the PermitControls row (Authority button + delete)
          // so the trash button doesn't overlap "Authority"; measured legacy
          // controls column was 164.5px on this mount.
          name: '__slot:permit-controls',
          title: '',
          width: '143'
        }
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
